import React, { Component } from 'react'
import { Button, notification, Alert, message } from 'antd';

class NewCommentForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      maincomment: '',
      loading: false,
      error: false
    }
  }

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  sendMainComment = (e) => {
    e.preventDefault()
    const { maincomment } = this.state
    const { postId, profile } = this.props
    if(!profile.uid) {
      message.error('You need to be logged in!');
    } else {
      this.setState({
        loading: true,
        error: false
      })
      if (maincomment.length) {
        let commentDetails = {
          maincomment,
          userId: profile.uid,
          fullName: profile.fullName,
          postId
        }
        this.props.sendComment(commentDetails)
        this.setState({
          loading: false,
          maincomment: ''
        })
      } else {
        this.setState({
          loading: false,
          error: true
        })
      }
    }
  }

  render() {
    return (
      <div className="reply-comment-form">
        <h4>Reply A Comment</h4>
        {
          this.state.error ? <div style={{ marginBottom: 1.5 + 'rem'}}>
            <Alert
              message="Warnig: You can not make an empty comment"
              type="warning"
            />
          </div> : null
        }
        <form action="#">
          <div className="row">
            <div className="col-sm-12">
              <textarea placeholder="Your Comment" name="maincomment" onChange={this.handleInputChange} value={this.state.maincomment}></textarea>
            </div>
          </div>
          <Button type="primary" loading={this.state.loading} size={'large'} onClick={this.sendMainComment}>
            Submit
        </Button>
          {/* <div className="clearfix"><input type="submit" value="Submit" className="float-right s-bg-color" onClick={(e)=>this.sendMainComment(e)}/></div> */}
        </form>
      </div>
    )
  }
}

export default NewCommentForm
